<template>
    <div class="app flex-row align-items-center"  style="background-image: url('customers/a6i/gift/fundo1.jpg'); background-size: cover; background-attachment: fixed; background-position: center;">
    <div class="container">
      <h1 style="font-family: 'Dancing Script', cursive;
  color: white;
  text-align: center; /* Optional: Center the heading */
  margin-top: 100px; /* Optional: Add some top margin */
  background-color: rgba(0, 0, 0, 0.5); /* Optional: Add a semi-transparent background */
  padding: 80px;
  text-shadow: 0 0 8px black; 
  ">Chá de Cozinha da Adriana</h1>
      <b-row class="justify-content-center">
            <div class="animated fadeIn">
            <b-row>
                <b-col sm="8" md="6" lg="4" v-for="item in items" :key="item.id">
                    <b-card :class="!item.personName ? 'card-accent-warning text-center' : 'bg-danger text-center'"
                      @click="selectItem(item)"
                    >
                        <template #header> 
                            <h4 class="mb-0">{{ item.productName }}</h4> </template>
                        <b-img
                            :src="'customers/a6i/gift/' + item.image" 
                            alt="Image description"
                            style="height: 200px; object-fit: cover;"
                            class="mr-3"
                        />
                        <b-card-body class="text-left">
                            {{ item.description }}
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row><!--/.row-->
            </div>
        </b-row>
    </div>


    
      <b-modal
                v-model="itemModal"
                id="item-modal"
                centered
                hide-footer
                :title="selectedItem.productName"
                size="md">

                <div class="animated fadeIn" v-show="!selectedItem.funItem">
    
                  <b-row v-show="!selectedItem.used">
                    <b-col>
                      <b-form>
                        <b-form-group
                        description=""
                        label="Entre com seu NOME para selecionar esse item:"
                        label-for="personName"
                        class="font-xl"
                        >
                          <b-row>
                            <b-col>
                                <b-form-input class="font-xl" v-model="selectedItem.personName" id="selectedItem.personName" type="text"></b-form-input>
                            </b-col>
                          </b-row>

                        </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>

                  <b-row v-show="selectedItem.used" class="text-center" style="color: red">
                    <b-form>
                        <b-form-group
                        description=""
                        label="Esse ítem já foi escolhido. Sinta-se a vontade para escolher outro, esses são apenas dicas!"
                        label-for="personName"
                        class="font-xl"
                        >
                        </b-form-group>          
                      </b-form>
                    <div class="font-xl"></div>
                  </b-row>

                  <div class="font-xl text-center" style="color: red" v-show="!selectedItem.used && selectedItem.personName && selectedItem.personName.length > 3">Clique em mim para confirmar!</div> 

                </div>

                <div class="font-xl text-center" style="color: red" v-show="selectedItem.funItem">Brincadeirinha... até parece né!?</div> 

                <b-img class="text-center"
                    :src="'customers/a6i/gift/' + (selectedItem.funItem ? 'fun1.png' : 'obrigado1.png')" 
                    alt="Bricadeirinha"
                    style="max-width: 100; height: auto;"
                    @click="saveItem()"
                  />


      </b-modal>
      
    </div>

  </template>
  
<script>
  import Vue from 'vue'
  import axios from "axios";
  
/* Toast */
import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */

  export default {
    name: 'cards',
    data: function () {
      return {
        selectedItem: { productName: '' },
        isBusy: false,
        itemModal: false,
        items: [],
        show: true
      }
    },
    methods: {
      async saveItem() {
        if(this.selectedItem.personName && this.selectedItem.personName.length > 3) {
          var s = this;
          var currentUser = this.$store.state.currentUser;

          var itemToSend = { ...this.selectedItem }
          itemToSend.uid = 100  

          console.log(itemToSend)

          await axios.post(
              this.$store.state.ws_url + "/giftlist/person",
              itemToSend

          ).then(function (resp) {
              s.refreshData()
              s.itemModal = false
          }
          ).catch(function (error) {
              toast ({
                  type: VueNotifications.types.error,
                  title: 'Seleção do Presente',
                  message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sistema Offline. Tente mais tarde.',
                  timeout: 5000
              })
          });
        }
        else {
          toast ({
                type: VueNotifications.types.error,
                title: 'Seleção do Presente',
                message: 'Parece que não foi digitado o seu NOME!',
                timeout: 5000
            })   
        }
      },
      selectItem(item) {
        this.selectedItem = { ...item };
        this.selectedItem.used = (this.selectedItem.personName && this.selectedItem.personName != "")
        this.itemModal = true
        console.log(item)
      },
      async refreshData() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          this.isBusy = true;
          await axios.get(
              this.$store.state.ws_url + "/giftlist"
          ).then(function (resp) {
              s.items = resp.data.obj;
          }
          ).catch(function (error) {
              toast ({
                  type: VueNotifications.types.error,
                  title: 'Erro',
                  message: 'Sem permissão de acesso. Verifique e tente novamente.',
                  timeout: 3000
              })
          });
          this.isBusy = false;
        
      }
    },
    mounted: function() {
      this.refreshData()
    }
  }
  </script>
  
  <style scoped>
    .fade-enter-active {
      transition: all .3s ease;
    }
    .fade-leave-active {
      transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .fade-enter, .fade-leave-to {
      transform: translateX(10px);
      opacity: 0;
    }
  </style>
  